import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { FullClient, FullClientType } from "@models/full-client.model";
import { MenuProfileDropdownComponent } from "@core/layout/components/top-bar/components/menu-profile/components/menu-profile-dropdown/menu-profile-dropdown.component";
import { AvatarModule, DropdownModule } from "@jack-sparrow-libraries/ui-kit";
import { SvgCentredIconComponent, SvgIconModule } from "features";
import { FullClientInitialesPipe } from "@core/pipes/full-client-initiales.pipe";
import { FullClientNamePipe } from "@core/pipes/full-client-name.pipe";
import { FullClientIconPipe } from "@core/pipes/full-client-icon.pipe";
import { ClientDroits } from "@jack-sparrow-libraries/emotion-models";

@Component({
	selector: "cba-menu-profile",
	templateUrl: "./menu-profile.component.html",
	styleUrls: ["./menu-profile.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		MenuProfileDropdownComponent,
		DropdownModule,
		SvgIconModule,
		AvatarModule,
		SvgCentredIconComponent,
		FullClientInitialesPipe,
		FullClientNamePipe,
		FullClientIconPipe,
	],
})
export class MenuProfileComponent {
	readonly $fullClient = input.required<FullClient>({ alias: "fullClient" });
	readonly $loading = input.required<boolean>({ alias: "loading" });

	readonly $droits = input.required<ClientDroits>({ alias: "droits" });

	readonly $isRemplacant = computed(() => this.$fullClient()?.type === FullClientType.REMPLACANT);
}
